module.exports = __webpack_public_path__ + "static/media/headerM2.0cfa9987.png";